"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = require("react");

var _dist = require("@low6dev/react-utils/dist");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var visibleStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  visibility: visible;\n  opacity: 1;\n"])));

var StyledWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 10;\n  left: 50%;\n  bottom: 80px;\n  width: 100%;\n  transform: translateX(-50%);\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.5s linear;\n\n  @media (min-width: ", ") {\n    width: 280px;\n  }\n\n  ", ";\n"])), function (p) {
  return p.theme.screenWidthMd;
}, function (p) {
  return p.isVisible && visibleStyles;
});

var StyledCloseButton = _styledComponents.default.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -50px;\n  right: 0;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  background: #0d0d0d;\n  color: #f9f9f9;\n  display: grid;\n  padding: 0;\n  place-items: center;\n"])));

var StyledLink = _styledComponents.default.a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 80px;\n"])));

var StyledImageWrapper = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 1rem;\n  bottom: 1rem;\n"])));

var StyledImage = _styledComponents.default.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 250px;\n"])));

var Wrapper = function Wrapper(_ref) {
  var ctaUrl = _ref.ctaUrl,
      imageUrl = _ref.imageUrl,
      activeBet = _ref.activeBet,
      showSubmissionPopup = _ref.showSubmissionPopup,
      appName = _ref.appName;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDismissed = _useState2[0],
      setDismissed = _useState2[1];

  var handleCloseClicked = function handleCloseClicked(e) {
    e.preventDefault();
    e.stopPropagation();
    setDismissed(true);
  };

  var openLink = function openLink(url) {
    var popupType = "Activebet";

    if (showSubmissionPopup === true) {
      popupType = "PickSubmission";
    }

    window.xtremepush("tag", "AffiliatePopup.Click.".concat(popupType), JSON.stringify({
      AppName: appName
    }));
    window.open(url, '_blank').focus();
  };

  var ScrollingPopup = function ScrollingPopup() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
      isVisible: !isDismissed,
      children: ctaUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, {
        onClick: function onClick() {
          return openLink(ctaUrl);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledImageWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCloseButton, {
            onClick: handleCloseClicked,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.MatIcon, {
              children: "close"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledImage, {
            src: (0, _dist.createImageCdnLink)(imageUrl)
          })]
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledImageWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCloseButton, {
          onClick: handleCloseClicked,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.MatIcon, {
            children: "close"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledImage, {
          src: (0, _dist.createImageCdnLink)(imageUrl)
        })]
      })
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: activeBet && imageUrl !== undefined || showSubmissionPopup ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ScrollingPopup, {}) : null
  });
};

var _default = Wrapper;
exports.default = _default;